import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { modalHelpers } from 'presentation/components/Modal/Modal.service';
import { AlertModalProps, ConfirmModalProps } from 'presentation/components/Modal/Modal.type';

interface AppSlice {
    fetchingCount: number;
}

const initialState: AppSlice = {
    fetchingCount: 0,
};

export const appSlice = createSlice({
    name: 'appSlice',
    initialState,
    reducers: {
        completeFetching: (state) => {
            //set fetchingCount to 0 if it is negative
            state.fetchingCount = state.fetchingCount <= 0 ? 0 : state.fetchingCount - 1;
        },
        startFetching: (state) => {
            state.fetchingCount += 1;
        },
        showConfirm: (state, action: PayloadAction<ConfirmModalProps>) => {
            modalHelpers.showConfirm(action.payload);
        },
        hideConfirm: () => {
            modalHelpers.hideConfirm();
        },
        showAlert: (state, action: PayloadAction<AlertModalProps>) => {
            modalHelpers.showAlert(action.payload);
        },
        hideAlert: () => {
            modalHelpers.hideAlert();
        },
    },
});

export const { completeFetching, startFetching, showConfirm, hideConfirm, showAlert, hideAlert } =
    appSlice.actions;
export default appSlice.reducer;
